import { render, staticRenderFns } from "./UcContractMiniCard.yaml?vue&type=template&id=609d1c63&component"
import script from "./UcContractMiniCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractMiniCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports